import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=d0f0b546&scoped=true&"
import script from "./Collapse.vue?vue&type=script&lang=js&"
export * from "./Collapse.vue?vue&type=script&lang=js&"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=d0f0b546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f0b546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0f0b546')) {
      api.createRecord('d0f0b546', component.options)
    } else {
      api.reload('d0f0b546', component.options)
    }
    module.hot.accept("./Collapse.vue?vue&type=template&id=d0f0b546&scoped=true&", function () {
      api.rerender('d0f0b546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Collapse.vue"
export default component.exports